import type { PageContext } from '@zto/zpage'
import dayjs from 'dayjs'

// 日志对话框
export const logDialog = {
  width: 600,
  top: '10vh',
  labelWidth: 0,
  itemSpan: 24,

  onShow: async ({ app, data }: PageContext) => {
    const res = await app.request({
      api: '/cabinet/admin/base/AdminBaseCommonQueryController/queryAuditLogPage',
      params: { bizNo: data.shipmentCode, logScene: 'oms.shipment_order_operate', current: 1, size: 100 }
    })

    return {
      payload: {
        operateLogData: res.data
      }
    }
  },

  formItems: [
    {
      label: '',
      labelWidth: 0,
      type: 'edit-table',
      prop: 'operateLogData',
      span: 24,
      noOperation: true,
      autoHeight: true,
      border: true,
      columns: [
        {
          label: '操作时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        },
        { prop: 'logDesc', label: '操作名称', minWidth: 160 },
        { prop: 'creator', label: '操作人', minWidth: 100 }
      ]
    }
  ],

  actions: {
    close: {}
  }
}

// 批量改价
export const batchChangeDialog = {
  width: 1000,
  labelWidth: 120,
  itemSpan: 24,

  onShow: async ({ app, data }: PageContext) => {
    const checkedArr = app.getPageData('checkedArr') || []
    const productInfoData = checkedArr?.slice(0, 1) // 取第一个
    return {
      payload: {
        ...data,
        productInfoData
      }
    }
  },

  formItems: [
    {
      label: '',
      labelWidth: 0,
      type: 'edit-table',
      prop: 'productInfoData',
      noIndex: true,
      noPager: true,
      noOperation: true,
      autoHeight: true,
      border: true,
      showSummary: false,
      columns: [
        { prop: 'productCode', label: '商品编号', minWidth: 100 },
        { prop: 'productName', label: '商品名称', minWidth: 100 },
        { prop: 'supplierName', label: '供应商', minWidth: 100 },
        { prop: 'productSpec', label: '商品规格', minWidth: 100 },
        {
          prop: 'costPrice',
          label: '成本价（元）',
          minWidth: 150,
          editor: {
            itemType: 'input-number',
            label: '',
            min: 0.01,
            max: 99999.99,
            precision: 2,
            required: true
          }
        },
        {
          prop: 'salePrice',
          label: '销售价（元）',
          minWidth: 150,
          editor: {
            itemType: 'input-number',
            label: '',
            min: 0.01,
            max: 99999.99,
            precision: 2,
            required: true
          }
        },
        {
          prop: 'linePrice',
          label: '划线价（元）',
          minWidth: 150,
          editor: {
            itemType: 'input-number',
            label: '',
            min: 0.01,
            max: 99999.99,
            precision: 2,
            required: true
          }
        }
      ],
      span: 24
    }
  ],

  beforeSubmit: async ({ app, data }: PageContext, model: any) => {
    return {
      shipList: data.shipList,
      costPrice: data?.productInfoData?.[0]?.costPrice,
      salePrice: data?.productInfoData?.[0]?.salePrice,
      linePrice: data?.productInfoData?.[0]?.linePrice
    }
  }
}
